import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_ASSORTGROUP, GET_COLORS, GET_SHAPEGROUP } from "../../../api/apiRoutes";
import { AssortGroup } from "../../../models/AssortGroup";

export default function useTickets() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [assortGroup, setAssortGroup] = useState<AssortGroup[]>([]);
  const [colorGroup, setColorGroup] = useState<AssortGroup[]>([]);
  const [shapeGroup, setShapeGroup] = useState<AssortGroup[]>([]);
  const [loading, setLoading] = useState(false);

  const requestGetAssortGroups = async (assortGroupIds?: string) => {
    setLoading(true);
    const { result, isError } = await get(GET_ASSORTGROUP(facilityIds, assortGroupIds));
    if (!isError) {
      setAssortGroup(result);
    }
    setLoading(false);
  };
  const requestGetColorGroups = async (colorIds?: string) => {
    setLoading(true);
    const { result, isError } = await get(GET_COLORS(facilityIds, colorIds));
    if (!isError) {
      setColorGroup(result);
    }
    setLoading(false);
  };

  const requestGetShapeGroup = async (shapeIds?: string) => {
    setLoading(true);
    const { result, isError } = await get(GET_SHAPEGROUP(facilityIds, shapeIds));
    if (!isError) {
      setShapeGroup(result);
    }
    setLoading(false);
  };

  return {
    requestGetAssortGroups,
    requestGetColorGroups,
    requestGetShapeGroup,
    assortGroup,
    colorGroup,
    shapeGroup,
    loading,
  };
}
